import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afc14d1a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/kft.ycxxkj.com/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc14d1a')) {
      api.createRecord('afc14d1a', component.options)
    } else {
      api.reload('afc14d1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=afc14d1a", function () {
      api.rerender('afc14d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/page1/index.vue"
export default component.exports